import { array, object, string } from "yup"

const internationalPhoneNumber = () =>
  string()
    .trim()
    .transform((v) => v.replace(/[^+0-9]_/g, ""))
    .matches(
      /\+[0-9]{1,3}[0-9]{4,14}/g,
      "Mobile Number format: +(country code, 1–3 digits) (phone number, 4–14 digits). Example: Country code: +01 and phone number: 123 1234 should be entered as +011231234"
    )

export const CONTACT_TYPE_VALUES = ["business", "reservation", "administrative", "financial"]

export const ContactSchema = object({
  firstName: string().trim().required().label("First Name"),
  lastName: string().trim().required().label("Last Name"),
  jobTitle: string().trim().required().label("Job Title"),
  emailAddress: string().trim().email().required().label("Email Address"),
  phoneNumber: internationalPhoneNumber().required().label("Phone Number"),
  mobileNumber: internationalPhoneNumber().required().label("Mobile Number"),
  contactType: string().required().oneOf(CONTACT_TYPE_VALUES).label("Contact Type"),
})

export const OperatorFormSchema = object({
  name: string().required(),
  registrationNumber: string(),
  vatNumber: string(),
  address: string().required(),
  contacts: array().of(ContactSchema),
})
